import { render } from "./ProposalListPage.vue?vue&type=template&id=20c6d497"
import script from "./ProposalListPage.vue?vue&type=script&lang=js"
export * from "./ProposalListPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/wallace/Desktop/projects/virtap/virtap-webapp-support/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__